module.exports = __webpack_public_path__ + "img/midBanner03.b2bed81b.png";